module.exports = __webpack_public_path__ + "img/user_hl_zx_selected.63f6655e.png";